import { nsSelector } from '../../../../../utils/redux';

const suppliersSelector = nsSelector('suppliers');
export const suppliers = suppliersSelector('list');
export const suppliersForSelect = suppliersSelector('listForSelect');
export const suppliersFiltered = suppliersSelector('listFiltered');
export const supplier = suppliersSelector('item');
